// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../warranty-expiration/state/criteria';
import {updateKeyValueSelectionList, updateList} from '../../../shared/services/list-selections';
import actions from '../../actions-list';
import {getDefaultState as getDateRangeDefaultState} from '../state/date-range';

const updateWarrantyExpirationAccountsCriteria = (state, action) =>

    Criteria.update(state, {
        selectedDealers: {
            $set: updateList(
                action.dealer,
                action.isSelected,
                'account',
                state.selectedDealers
            )
        }
    });

const updateFetchWarrantTypes = (state, action) =>
    Criteria.update(state, {
        warrantyTypes: {
            allowed: {
                $set: action.data
            }
        }
    });

const updateWarrantyExpirationWarrantyTypes = (state, action) =>
    Criteria.update(state, {
        warrantyTypes: {
            selected: {
                $set: updateKeyValueSelectionList(
                    action.warrantyType,
                    action.isSelected,
                    state.warrantyTypes.selected
                )
            }
        }
    });

const updateExpirationDate = (state, action) =>
    Criteria.update(state, {
        expirationDate: {
            from: {
                $set: action.expirationDateRange.from
            },
            to: {
                $set: action.expirationDateRange.to
            }
        }
    });

const updateSelectAllDealers = (state, action) => {

    const toggleSelectedDealersState = state.selectedDealers.length ?
        [] :
        action.dealers;

    return Criteria.update(state, {
        selectedDealers: {
            $set: toggleSelectedDealersState
        }
    });

};

const updateSelectAllWarrantyTypes = state => {

    const toggleSelectedTypesState = state.warrantyTypes.selected.length ?
        [] :
        state.warrantyTypes.allowed;

    return Criteria.update(state, {
        warrantyTypes: {
            selected: {
                $set: toggleSelectedTypesState
            }
        }
    });

};

const updateAllDealersOnLoad = (state, action) =>
    Criteria.update(state, {
        selectedDealers: {
            $set: action.dealers
        }
    });

const resetWarrantyExpirationCriteria = (state, action) =>
    Criteria.update(state, {
        expirationDate: {$set: getDateRangeDefaultState()},
        selectedDealers: {$set: action.dealers},
        warrantyTypes: {
            selected: {$set: []}
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_WARRANTY_EXPIRATION_CRITERIA]: resetWarrantyExpirationCriteria,
        [actions.UPDATE_WARRANTY_EXPIRATION_ACCOUNTS_CRITERIA]: updateWarrantyExpirationAccountsCriteria,
        [actions.UPDATE_FETCH_WARRANTY_TYPES_SUCCESS]: updateFetchWarrantTypes,
        [actions.UPDATE_WARRANTY_EXPIRATION_EXPIRATION_DATE]: updateExpirationDate,
        [actions.UPDATE_WARRANTY_EXPIRATION_WARRANTY_TYPES]: updateWarrantyExpirationWarrantyTypes,
        [actions.WARRANTY_EXPIRATION_SELECT_ALL_ACCOUNTS_CRITERIA]: updateSelectAllDealers,
        [actions.WARRANTY_EXPIRATION_SELECT_ALL_ACCOUNTS_ON_LOAD]: updateAllDealersOnLoad,
        [actions.WARRANTY_EXPIRATION_SELECT_ALL_TYPES_CRITERIA]: updateSelectAllWarrantyTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/reducers/criteria.js